/**
 * AnonTrialExhausted — PRI-503 anon free-trial exhaustion state.
 *
 * Shown when anonymous key provisioning hits the server-side IP cap
 * (sandbox_limit_exceeded / upgrade_limit_exceeded) — the visitor's free
 * trial for this network is used up. Friendly, non-error framing with a
 * signup CTA (signing up carries usage over via the device-claim flow).
 *
 * App-plane component (brand asset — logo rule: Darwin_v3_vinyl_transparent.png).
 */
import { L } from '../../core/components/v2/pv2-shared'

export function AnonTrialExhausted({ onDismiss }: { onDismiss?: () => void }) {
  return (
    <div
      data-testid="anon-trial-exhausted"
      style={{
        position: 'fixed', inset: 0, zIndex: 9000,
        background: 'rgba(26,25,22,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{
        maxWidth: 420, width: '100%', background: L.bgSurface,
        border: `1px solid ${L.border}`, borderRadius: 16,
        padding: '40px 32px', textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 24 }}>
          <img src="/Darwin_v3_vinyl_transparent.png" alt="" style={{ height: 32, width: 'auto', objectFit: 'contain' }} />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15, textAlign: 'left' }}>
            <span style={{ fontSize: 15, fontWeight: 300, color: L.textPrimary, letterSpacing: '-0.025em' }}>Primate</span>
            <span style={{ fontSize: 15, fontWeight: 300, color: L.signal, letterSpacing: '-0.025em' }}>Intelligence</span>
          </div>
        </div>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: L.textPrimary, margin: '0 0 12px' }}>
          Your free trial has been used
        </h2>
        <p style={{ fontSize: 15, color: L.textMuted, lineHeight: 1.6, margin: '0 0 24px' }}>
          The anonymous free trial for this network is used up. Create a free
          account to keep going — no card required, and your trial usage
          carries over.
        </p>
        <a
          href="/signup"
          style={{
            display: 'inline-block', background: L.signal, color: '#fff',
            fontSize: 15, fontWeight: 500, padding: '12px 28px',
            borderRadius: 10, textDecoration: 'none',
          }}
        >
          Sign up free
        </a>
        <div style={{ marginTop: 16 }}>
          <a href="/login" style={{ fontSize: 13, color: L.textMuted, textDecoration: 'underline' }}>
            Already have an account? Sign in
          </a>
        </div>
        {onDismiss && (
          <div style={{ marginTop: 12 }}>
            <button
              data-testid="anon-trial-exhausted-dismiss"
              onClick={onDismiss}
              style={{ fontSize: 12, color: L.textMuted, background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}
            >
              Not now
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
